import React from 'react';
import PropTypes from 'prop-types';
import styledComponent from '../../../utils/styledComponent';
import theme from '../../../theme';

const StyledDiv = styledComponent('div', {
  display: 'flex',
  flexDirection: 'column',

  '& .form-field-label': {
    ...theme.typography.label,
    color: theme.colors.text,
    marginBottom: theme.spacing.labelGap,
  },

  '& .form-field-required': {
    color: theme.colors.danger,
    marginLeft: theme.spacing.requiredGap,
  },

  '& .form-field-hint': {
    color: theme.colors.textHint,
    ...theme.typography.hint,
    marginTop: theme.spacing.hintGap,
  },
});

function FormField({ id, label, hint, required, children }) {
  const labelContent = (
    <>
      {label}
      {required && <span className="form-field-required">*</span>}
    </>
  );

  return (
    <StyledDiv>
      {id ? (
        <label htmlFor={id} className="form-field-label">
          {labelContent}
        </label>
      ) : (
        <span className="form-field-label">{labelContent}</span>
      )}
      {children}
      {hint && <span className="form-field-hint">{hint}</span>}
    </StyledDiv>
  );
}

FormField.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  hint: PropTypes.string,
  required: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

FormField.defaultProps = {
  id: null,
  hint: null,
  required: false,
};

export default FormField;
